import React from "react";
import { Overview } from "../molecules/Overview";
import { MetricsOverview } from "./MetricsOverview";

export const Dashboard = () => {
  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-gray-50 via-white to-gray-100 overflow-hidden">
      {/* Fixed Header/Overview Section */}
      <div className="flex-shrink-0">
        <Overview />
      </div>

      {/* Scrollable Main Content */}
      <main className="flex-1 overflow-y-auto custom-scrollbar">
        <div className="container mx-auto px-4 py-8">
          {/* Metrics Grid */}
          <MetricsOverview />

          {/* Additional Dashboard Sections */}
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Recent Activity Card */}
            <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900">Recent Activity</h3>
                <button className="text-sm text-yellow-600 hover:text-yellow-700 font-medium">
                  View All →
                </button>
              </div>
              
              {/* Scrollable activity list */}
              <div className="space-y-4 max-h-96 overflow-y-auto custom-scrollbar pr-2">
                {[
                  { action: "New request submitted", time: "2 hours ago", status: "pending" },
                  { action: "Approval needed for Request ", time: "1 day ago", status: "action" },
                  { action: "Interview scheduled for Candidate ", time: "2 days ago", status: "pending" },
                  { action: "Request  needs review", time: "5 days ago", status: "action" },
                ].map((activity, i) => (
                  <div 
                    key={i}
                    className="flex items-center justify-between p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors duration-200 cursor-pointer group"
                  >
                    <div className="flex items-center space-x-4">
                      <div className={`w-2 h-2 rounded-full flex-shrink-0 ${
                        activity.status === 'completed' ? 'bg-green-400' :
                        activity.status === 'action' ? 'bg-red-400' :
                        'bg-yellow-400'
                      }`}></div>
                      <div>
                        <p className="font-medium text-gray-900 group-hover:text-yellow-600 transition-colors">
                          {activity.action}
                        </p>
                        <p className="text-sm text-gray-500">{activity.time}</p>
                      </div>
                    </div>
                    <svg className="w-5 h-5 text-gray-400 group-hover:text-yellow-600 transition-colors flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="h-8"></div>
        </div>
      </main>
    </div>
  );
};